import { BarChart3, Table as TableIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../client/components/ui/tooltip";
import { cn } from "../../client/utils";
import useTranslation from "../../client/hooks/useTranslation";

export default function ChartViewToggle({
  value,
  onChange,
}: {
  value: "chart" | "table";
  onChange?: (v: "chart" | "table") => void;
}) {
  const t = useTranslation();
  if (!onChange) return null;
  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center gap-0.5 rounded-md border border-border/60 p-0.5">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => onChange("chart")}
              className={cn(
                "flex h-6 w-6 items-center justify-center rounded transition-colors",
                value === "chart" ? "bg-primary/10 text-primary" : "text-muted-foreground hover:text-foreground"
              )}
              aria-label={t.analytics.chartView}
            >
              <BarChart3 className="h-3.5 w-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" className="text-xs">{t.analytics.chartView}</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => onChange("table")}
              className={cn(
                "flex h-6 w-6 items-center justify-center rounded transition-colors",
                value === "table" ? "bg-primary/10 text-primary" : "text-muted-foreground hover:text-foreground"
              )}
              aria-label={t.analytics.tableView}
            >
              <TableIcon className="h-3.5 w-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" className="text-xs">{t.analytics.tableView}</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
